<app-loader></app-loader>
<app-environment></app-environment>
<div class="page page--grey-bg" id="page-top">
  <div class="site-nav">
    <nav class="site-nav__wrap">
      <div class="site-nav__top">
        <img src="assets/img/ok-logo.svg" alt="OK a.m.b.a." />
      </div>
      <div class="site-nav__bottom">
        <a
          matTooltip="Brugerindstillinger"
          class="cursor-pointer"
          [matMenuTriggerFor]="menu"
          ><mat-icon svgIcon="avatar"></mat-icon><span>Profil</span></a
        >
        <mat-menu #menu="matMenu">
          <a mat-menu-item (click)="logout()">
            <mat-icon
              aria-hidden="false"
              aria-label="Log ud"
              svgIcon="logout"
            ></mat-icon>
            <span>Log ud</span>
          </a>
          <hr />
          <app-version></app-version>
        </mat-menu>
      </div>
    </nav>
  </div>
  <main class="page__main">
    <div class="wrap">
      <div class="topbar">
        <h1>Ekstern EGIS portal</h1>
        <div class="topbar__actions"></div>
      </div>
      <div class="page__content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
  <footer class="page__footer">
    <div
      class="runway runway--grey-white runway--centered runway--border-top footer-logo"
    ></div>
  </footer>
</div>
